// @material-ui/core
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import Moment from "react-moment";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  }
});

function BasicTable(props) {
  const { classes, headers, data } = props;

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => {
              return <TableCell key={index}>{header}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((items, index) => {
            return (
              <TableRow key={index}>
                {items.length > 0 &&
                  items.map((item, index) => {
                    return (
                      <TableCell key={index} numeric={item.numeric}>
                        {item.date ? (
                          <Moment format="DD.MM.YYYY">{item.value}</Moment>
                        ) : (
                          item.value
                        )}
                      </TableCell>
                    );
                  })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}

BasicTable.propTypes = {
  classes: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired
};

export default withStyles(styles)(BasicTable);



// WEBPACK FOOTER //
// ./src/library/list/index.js